// @explanation to avoid tight coupling to immutable.js @lukavyi
export const selectData = (store, path, defaultValue) => {
  if (store) {
    return store.get(path, defaultValue);
  }
  return defaultValue;
};

export default {
  selectData,
};
